import { DeadlineCategory, DeadlinePriority } from '../types';

export interface DeadlineTemplate {
  key: string;
  title: string;
  category: DeadlineCategory;
  priority: DeadlinePriority;
  /** Předvyplněná poznámka – perioda + právní základ; datum si zadává předseda podle poslední revize/smlouvy. */
  note: string;
}

/**
 * Šablony vlastních termínů (periody ověřeny rešerší 7/2026 proti primárním zdrojům).
 * Texty česky přímo v configu – stejný přístup jako Registry/config/registryData.ts.
 */
export const deadlineTemplates: DeadlineTemplate[] = [
  {
    key: 'kominy',
    title: 'Kontrola spalinových cest (komíny)',
    category: 'revision',
    priority: 'normal',
    note: 'Provádí se nejméně 1× ročně (vyhláška č. 34/2016 Sb.). U spotřebičů na pevná paliva se čištění provádí 2–3× ročně.',
  },
  {
    key: 'elektro',
    title: 'Revize elektroinstalace společných prostor',
    category: 'revision',
    priority: 'normal',
    note: 'Provádí se 1× za 5 let (NV č. 190/2022 Sb.). Zadejte datum příští revize podle poslední revizní zprávy.',
  },
  {
    key: 'hromosvod',
    title: 'Revize hromosvodu',
    category: 'revision',
    priority: 'normal',
    note: 'Revize 1× za 4 roky, vizuální kontrola 1× ročně (NV č. 190/2022 Sb.).',
  },
  {
    key: 'plyn-kontrola',
    title: 'Kontrola plynových rozvodů',
    category: 'revision',
    priority: 'normal',
    note: 'Provádí se 1× ročně (NV č. 191/2022 Sb.). Týká se společných rozvodů od HUP po plynoměry.',
  },
  {
    key: 'plyn-revize',
    title: 'Provozní revize plynového zařízení',
    category: 'revision',
    priority: 'normal',
    note: 'Provádí se 1× za 3 roky revizním technikem (NV č. 191/2022 Sb.).',
  },
  {
    key: 'vytah-zkouska',
    title: 'Odborná zkouška výtahu',
    category: 'revision',
    priority: 'normal',
    note: 'Provádí se 1× za 3 roky (NV č. 193/2022 Sb.). Pravidelné odborné prohlídky (à 3–4 měsíce) obvykle zajišťuje servisní firma.',
  },
  {
    key: 'vytah-inspekce',
    title: 'Inspekční prohlídka výtahu',
    category: 'revision',
    priority: 'normal',
    note: 'Provádí se 1× za 6 let (NV č. 193/2022 Sb.).',
  },
  {
    key: 'hasicaky',
    title: 'Kontrola hasicích přístrojů',
    category: 'revision',
    priority: 'normal',
    note: 'Kontrola provozuschopnosti nejméně 1× ročně (vyhláška č. 246/2001 Sb.).',
  },
  {
    key: 'kotelna',
    title: 'Odborná prohlídka kotelny',
    category: 'revision',
    priority: 'normal',
    note: 'Nízkotlaká kotelna: odborná prohlídka 1× ročně (vyhláška č. 91/1993 Sb.). Tlakové nádoby (expanzomat): provozní revize 1× ročně (NV č. 192/2022 Sb.).',
  },
  {
    key: 'penb',
    title: 'Konec platnosti PENB',
    category: 'document',
    priority: 'normal',
    note: 'Průkaz energetické náročnosti budovy platí 10 let od vyhotovení (zákon č. 406/2000 Sb.). Nový je potřeba při prodeji či pronájmu jednotek.',
  },
  {
    key: 'pojistka',
    title: 'Výročí pojistné smlouvy',
    category: 'finance',
    priority: 'high',
    note: 'Cca 2 měsíce před výročím doporučujeme nechat zpracovat aktuální odhad reprodukční ceny domu a vyjednat co nejlepší pojistné podmínky.',
  },
  {
    key: 'uver-fixace',
    title: 'Konec fixace úvěru',
    category: 'finance',
    priority: 'high',
    note: 'S dostatečným předstihem (3–6 měsíců) porovnejte nabídky refinancování a vyjednejte podmínky s bankou.',
  },
];
